import(/* webpackMode: "eager" */ "/app/packages/stadium-shops-dashboard/src/app/(withProviderRoutes)/(withFooterOnly)/main.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MinimalFooter"] */ "/app/packages/stadium-shops-dashboard/src/client/wrappers.js");
